import { useFluxPath } from '@/hybrid/core/hooks/useFluxPath.hook';
import { ASSET_GROUP_VIEW } from '@/worksheet/worksheet.constants';
import { sqWorksheetStore } from '@/core/core.stores';

export const useIsAssetGroupView = () => {
  const isAssetGroupView = useFluxPath(sqWorksheetStore, () => sqWorksheetStore.view.key === ASSET_GROUP_VIEW.key);

  return { isAssetGroupView };
};
